<template>
  <div id="embed_video">
    <div v-if="!show404 && !show403" class="player_video">
      <iframe v-if='!isLoading&&token' :src="src" allow="autoplay" id="iframe_player" scrolling="no" frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen allowfullscreen width="100%" height="100%"></iframe>
    </div>
    <page404 v-if="show404 && !show403"></page404>
    <page403 v-if="show403"></page403>
  </div>
</template>
<script>
  import LoadingScreen from './Loading.vue'
  import Page404 from './404.vue'
  import Page403 from './403.vue'

  export default {
    name: 'widget_video',
    components: {LoadingScreen, Page404, Page403},
    data() {
      return {
        query: {},
        src: {},
        token: "",
        isLoading: true,
        show404: false,
        show403: false
      }
    },
    methods: {

      readyPlayer(param) {
      },
      fetchVideoEmbed(token) {
        let self = this;
        this.$service.getPreviewLinkByToken({token: token, options: this.query}).then(function (resp) {
          if (resp.data.link) {
            document.querySelector('head title').innerText = resp.data.title;
            self.src = resp.data.link;
            self.isLoading = false;

          } else {

            this.show403 = true;
          }
        }.bind(this))
          .catch(function (error) {
            self.isLoading = false;
            self.show404 = true;
          }.bind(this));
      }
    },
    created() {
      this.token = this.$route.params.token;
      this.query = Object.assign({
        skin: 'dark',
        plugin: 'navigation',
        token: this.$route.query.token ? this.$route.query.token : this.token
      }, this.$route.query);
      if (this.$route.query.op && this.$route.query.op === "1") {
        this.query.withoutApi = true
      } else {
        this.query.withoutApi = false;
      }
      let referer = document.referrer.split('/')[2] ? document.referrer.split('/')[2] : document.referrer;
      if (referer) {
        this.query.referer = referer;
      }
      this.fetchVideoEmbed(this.$route.params.token);
    }
  }
</script>
<style lang="scss">
  div#embed_video, .player_video {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }


</style>



// WEBPACK FOOTER //
// src/components/WidgetVideoByTocken.vue